/* STR8SHOP ensures one beat preview plays at a time across every storefront component. */
(function(){
  function init(root){
    (root||document).querySelectorAll('audio[data-s8-preview-audio]:not([data-s8-preview-ready])').forEach(function(audio){
      audio.setAttribute('data-s8-preview-ready','true');
      audio.addEventListener('play',function(){
        document.querySelectorAll('audio[data-s8-preview-audio]').forEach(function(other){
          if(other!==audio && !other.paused){other.pause();try{other.currentTime=0;}catch(e){}}
        });
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',function(){init(document);});
})();
